import React from "react";

export function ClarityStatement({ line }) {
    return (
        <div
            className="relative rounded-3xl border border-klareet-bor bg-gradient-to-br from-klareet-CARD to-[#0B1120] p-8 md:p-12 overflow-hidden animate-fade-up"
            data-testid="clarity-statement"
        >
            <div
                className="absolute -bottom-24 -left-24 w-80 h-80 rounded-full blur-3xl opacity-20 pointer-events-none bg-klareet-T"
                aria-hidden
            />
            <div className="text-[11px] uppercase tracking-[0.2em] text-klareet-MUT font-mono">
                Career clarity statement
            </div>
            <blockquote className="relative mt-5 text-2xl md:text-3xl leading-snug text-klareet-TEXT font-semibold italic tracking-tight max-w-3xl">
                “{line}”
            </blockquote>
        </div>
    );
}
